export class LanguageAsset {
	lang: string;
	label: string;
	langLabel: string;
	direction: string;
	langCode: string;
}
